(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkt-deals-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('mkt-deals-{{ section.id }}');
    if (!root) return;
    const rail = root.querySelector('.rail');
    const prev = root.querySelector('.prev');
    const next = root.querySelector('.next');
    function step(dir){ rail.scrollBy({ left: dir * 320, behavior: 'smooth' }); }
    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));
  })();
  
  } catch(e) { console.error(e); }
})();
})();
